import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DatasourceQueryGql: DocumentNode = gql`
query DatasourceQuery($vizportalUrlId: String!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}, permissionMode: FILTER_RESULTS) {
    name
    luid
  }
}
`;
